<template>
  <div class="auth-activator">
    <slot v-bind="scope" />

    <transition name="slide-right">
      <auth-sidebar
        v-if="isActive"
        v-bind="bindings"
        @close="deactivate"
        @back="deactivate"
        @auth-done="deactivate"
      />
    </transition>
    <transition name="fade">
      <div
        v-if="isActive"
        class="backlight"
        @click="deactivate"
      ></div>
    </transition>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import AuthSidebar from './auth-sidebar.vue'
export default {
  name: 'auth-activator',
  components: {
    AuthSidebar
  },
  props: {
    loginRegistration: {
      type: Object,
    },
    defaultComponent: {
      type: String,
      default: 'login'
    }
  },
  computed: {
    bindings() {
      return {
        defaultComponent: this.currentComponent || this.defaultComponent,
        outerActivator: this.outerActivator
      }
    },
    scope() {
      return {
        isActive: this.isActive,
        activate: this.activate,
        deactivate: this.deactivate,
      }
    }
  },
  data: () => ({
    isActive: false,
    currentComponent: null,
    outerActivator: null
  }),
  async created() {
    if (this.loginRegistration) {
      await this.updateAuthComponents(this.loginRegistration)
    }
  },
  methods: {
    ...mapActions('auth', ['updateAuthComponents']),
    async activate(component, activator) {
      if (typeof component === 'string') {
        this.currentComponent = component
      }
      if (activator) {
        this.outerActivator = activator
      }
      this.isActive = true
    },
    async deactivate() {
      this.isActive = false
      this.$nextTick(() => {
        this.outerActivator = null
      })
    },
  }
}
</script>